<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle :title="$route.meta.title"></PageTitle>
        <b-card>
          <div slot="footer">
            <b-row>
              <b-col sm="12">
                <router-link tag="button" class="btn btn-warning float-right" role="button"
                             :to="{name: 'jasperEditRoute', params:{jasper: jasper}}">{{ $t('page.generic.edit') }}
                </router-link>
              </b-col>
            </b-row>
          </div>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">Jasper URI</dt>
              <dd class="col-sm-9">{{jasper.uri}}</dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3">Filename</dt>
              <dd class="col-sm-9">{{jasper.filename}}</dd>
            </dl>
            <dl class="row">
              <dt class="col-sm-3">Percorso</dt>
              <dd class="col-sm-9">{{jasper.path}}</dd>
            </dl>
          </div>
        </b-card>
        <b-card title="Template Jasper Report">
          <div class="bd-example">
            <div class="row">
              <codemirror v-model="jasperData" :options="cmOptions"></codemirror>
            </div>
          </div>
        </b-card>
        <b-card title="Modelli Collegati" v-if="jasperModels.length > 0">
          <b-table :stacked="stacked" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered"
                   :small="small"
                   :fixed="fixed"
                   responsive="sm" :items="jasperModels" :fields="captions" :current-page="currentPage"
                   :per-page="perPage">
            <template slot="enabled" slot-scope="data">
              <b-badge :variant="getBadge(data.item.enabled)">{{activeDesc(data.item.enabled)}}</b-badge>
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                          next-text="Next" hide-goto-end-buttons/>
          </nav>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle'
  // require component
  import {codemirror} from 'vue-codemirror'
  // require styles
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/xml/xml.js'

  import JasperService from "@/services/JasperService"
  import i18n from '@/config/i18n'

  const jasperService = JasperService.build();

  export default {
    name: 'JasperShow',
    props: {
      uri: {
        required: true
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      fields: {
        type: [Array, Object],
        default: () => [
          {key: 'code', label: 'Codice', sortable: true},
          {key: 'modelVersion', label: 'Versione', sortable: true, formatter: 'versionFormatter'},
          {key: 'enabled', label: 'Abilitato', sortable: true},
          {key: 'label', label: 'Label', sortable: true},
        ]
      },
      perPage: {
        type: Number,
        default: 10
      },
      dark: {
        type: Boolean,
        default: false
      }
    },
    components: {
      PageTitle,
      codemirror
    },
    data() {
      return {
        jasperData: '',
        jasperModels: [],
        currentPage: 1,
        cmOptions: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'application/xml',
          lineWrapping: true,
          theme: 'default',
          readOnly: 'nocursor'
        }

      }
    },
    computed: {
      jasper: function () {
        return {
          uri: this.uri,
          filename: this.uri.substring(this.uri.lastIndexOf("/") + 1),
          path: this.uri.substring(this.uri.indexOf("/"), this.uri.lastIndexOf("/"))
        }

      },
      totalRows: function () {
        return this.getRowCount()
      },
      captions: function () {
        return this.fields
      }
    },
    created() {
      // fetch the data when the view is created and the data is
      // already being observed
      this.fetchData()
    },
    methods: {
      async fetchData() {
        let response = await jasperService.jrxml(this.uri);
        this.jasperData = response.data;
        this.jasperModels = await jasperService.models(this.uri)
      },
      getRowCount: function () {
        return this.jasperModels.length
      },
      getBadge(active) {
        return active ? 'success' : 'danger'
      },
      activeDesc: function (value) {
        return value ? i18n.tc('page.generic.enabled') : i18n.tc('page.generic.disabled')
      },
      versionFormatter(value) {
        return `V-${value < 10 ? '0' + value : value}`
      },
    }
  }
</script>
